import { render } from "./ShowMarks.vue?vue&type=template&id=55c3598a"
import script from "./ShowMarks.vue?vue&type=script&lang=ts"
export * from "./ShowMarks.vue?vue&type=script&lang=ts"
script.render = render

export default script